module.exports = __webpack_public_path__ + "img/icon.3f313816.svg";